import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
//Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import LeftIcon from "@mui/icons-material/ChevronLeft";
import RightIcon from "@mui/icons-material/ChevronRight";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { withi18n } from "../../../../../customer/components";
import { formatSuggesterAnswerConfidence } from "../../../..";
import { useExpertSuggestedAnswersContext } from "../../../../../expert";
import InfoDialog from "../../../dialogs/info-dialog/InfoDialog";
import SAFullScreenDialog from "./sa-full-screen-dialog/SAFullScreenDialog";
import ExpertTimePosted from "../expert-time-posted/ExpertTimePosted";
import ExpertDialogueBody from "../expert-dialogue-body/ExpertDialogueBody";
import PortalButton from "../../../buttons/portal-button/PortalButton";
import Button from "@limitless/modern/inputs/button/Button";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import InfoIcon from "@limitless/icons/InfoCircle";
const SuggestedAnswerDialogueCarousel = ({
  dialogue,
  message,
  theme,
  classes,
  t,
  suggestedAnswersProps,
  handleFullScreen
}) => {
  const log = pilog.getLogger("SuggestedAnswerDialogueCarousel");
  const {
    created,
    suggestedAnswers
  } = dialogue;
  const saContext = useExpertSuggestedAnswersContext();
  log.debug(saContext);
  const {
    saState,
    selectAnswer,
    showSuggestedAnswers,
    dismissAnswers
  } = saContext;
  const {
    hasDismissed
  } = saState;
  const [value, setValue] = React.useState(0);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [openInformationPopup, setOpenInformationPopup] = React.useState(false);
  const [scrollTo, setScrollTo] = React.useState("bottom");
  let bottomAreaDiv = null;
  const scrollToBottom = () => {
    // When in FullScreen SA, if we click on Personlize button, component scrolls up every time.
    if (bottomAreaDiv && fullScreen === true && scrollTo === "bottom") {
      setTimeout(() => bottomAreaDiv.scrollIntoView({
        block: "end",
        behavior: "instant"
      }), 10);
    }
  };
  React.useEffect(() => {
    if (scrollToBottom) {
      scrollToBottom();
    }
  }, [fullScreen]);

  //for any reason we don't want to show them or we have no SAs, return an empty div
  if (!showSuggestedAnswers || !suggestedAnswers) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  const currentAnswer = suggestedAnswers[value];
  log.debug(currentAnswer);
  const areCustomerDismissed = currentAnswer.state === "dismissed";
  const moreThanOneSA = suggestedAnswers.length >= 2;
  let showSuggestedAnswerButtons = message.conversationState.showSuggestedAnswersOptions;
  if (hasDismissed || areCustomerDismissed) {
    showSuggestedAnswerButtons = false;
  }
  const renderAnswers = (mainClasses = {}) => {
    const allClasses = {
      ...classes,
      ...mainClasses
    };
    return suggestedAnswers.map((answer, index) => {
      return /*#__PURE__*/React.createElement("div", {
        id: `sa-${index + 1}`,
        className: allClasses.responseListItem,
        key: index
        //ref={el => (this.swipeableView = el)}
      }, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
        body: answer.body
      }));
    });
  };
  const handleChangeIndex = index => {
    setValue(index);
  };
  const toggleFullScreen = () => {
    setFullScreen(!fullScreen);
    setScrollTo("top");
    if (handleFullScreen) {
      handleFullScreen(!fullScreen);
    }
  };
  const handlePersonalizeBtn = () => {
    setFullScreen(false);
    setScrollTo("bottom");
    selectAnswer(currentAnswer);
  };
  const handleCancelBtn = () => {
    setFullScreen(false);
    dismissAnswers();
  };
  const toggleInfoPopup = () => {
    setOpenInformationPopup(!openInformationPopup);
  };
  const leftArrowClick = () => {
    const currentSlide = value - 1;
    if (currentSlide >= 0) {
      setValue(currentSlide);
    }
  };
  const rightArrowClick = () => {
    const currentSlide = value + 1;
    if (currentSlide < suggestedAnswers.length) {
      setValue(currentSlide);
    }
  };
  const renderPersonaliseButtons = showClose => {
    if (showSuggestedAnswerButtons) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.footerContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.saBottom,
        ref: div => {
          bottomAreaDiv = div;
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "text",
        size: "small",
        id: "dismissBtn",
        onClick: handleCancelBtn
      }, t("Dismiss")), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        size: "small",
        id: "personaliseBtn",
        onClick: handlePersonalizeBtn
      }, t("Personalise"))), /*#__PURE__*/React.createElement("div", {
        className: classes.fullScreenIcon
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: toggleFullScreen,
        buttonId: showClose ? "closeFsButton" : "fullScreenButton",
        icon: /*#__PURE__*/React.createElement(FullscreenIcon, null),
        label: "Full Screen"
      })));
    }
    if (showClose) {
      return /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(PortalButton, {
        onClick: () => setFullScreen(false)
      }, "Close"));
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  const getTitle = () => {
    if (moreThanOneSA) {
      if (areCustomerDismissed) {
        return t("Dismissed Suggested Answers");
      } else {
        return t("Suggested Answers");
      }
    } else {
      if (areCustomerDismissed) {
        return t("Dismissed Suggested Answer");
      } else {
        return t("Suggested Answer");
      }
    }
  };
  const title = getTitle();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.listItem,
    style: suggestedAnswersProps.fullWidth ? {
      width: "100%",
      maxWidth: "100%",
      marginLeft: "unset"
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.responseWrapper} ${showSuggestedAnswerButtons ? classes.fullscreenBorderRadious : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "inherit",
    classes: {
      root: classes.titleRoot
    },
    align: "center",
    tabIndex: "0"
  }, title)), moreThanOneSA && /*#__PURE__*/React.createElement(Typography, {
    color: theme => theme.palette.text.primary,
    variant: "caption",
    align: "center",
    tabIndex: "0"
  }, value + 1, "/ ", suggestedAnswers.length), /*#__PURE__*/React.createElement("div", {
    className: classes.outerBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.arrowArea
  }, moreThanOneSA && /*#__PURE__*/React.createElement(LeftIcon, {
    onClick: leftArrowClick,
    className: value === 0 ? classes.arrowDisableIcon : classes.arrowIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.saBodyArea
  }, /*#__PURE__*/React.createElement(SwipeableViews, {
    axis: theme.direction === "rtl" ? "x-reverse" : "x",
    index: value,
    onChangeIndex: handleChangeIndex,
    containerStyle: {
      height: "100%"
    },
    slideStyle: {
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      marginBottom: 5
    }
  }, renderAnswers()), currentAnswer.suggestedAnswerScore && /*#__PURE__*/React.createElement("div", {
    className: classes.confidenceContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    color: theme => theme.palette.text.primary,
    variant: "caption"
  }, t("{0}% confidence", formatSuggesterAnswerConfidence(currentAnswer.suggestedAnswerScore))))), /*#__PURE__*/React.createElement("div", {
    className: classes.arrowArea
  }, moreThanOneSA && /*#__PURE__*/React.createElement(RightIcon, {
    onClick: rightArrowClick,
    className: value === suggestedAnswers.length - 1 ? classes.arrowDisableIcon : classes.arrowIcon
  }))), renderPersonaliseButtons(false)), /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, areCustomerDismissed && /*#__PURE__*/React.createElement(IconButton, {
    tooltipPlacememnt: "bottom-end",
    icon: /*#__PURE__*/React.createElement(InfoIcon, null),
    classes: {
      tooltip: classes.tooltip
    },
    label: "These answers have already been seen and rejected by the customer. Please do not copy paste this answer. "
  }))), !suggestedAnswersProps.hideDate && /*#__PURE__*/React.createElement(ExpertTimePosted, {
    dialogue: dialogue,
    time: created
  }), openInformationPopup && /*#__PURE__*/React.createElement(InfoDialog, {
    informationText: "These answers have already been seen and rejected by the customer. Please do not copy paste this answer. ",
    headerText: "Dismissed Suggested Answer",
    onCancelClick: toggleInfoPopup
  }), fullScreen && /*#__PURE__*/React.createElement(SAFullScreenDialog, {
    t: t,
    open: fullScreen,
    currentAnswer: currentAnswer,
    title: title,
    onClose: () => setFullScreen(false),
    value: value,
    totalSuggestedAnswer: suggestedAnswers.length,
    onChangeIndex: handleChangeIndex,
    renderAnswers: renderAnswers,
    leftArrowClick: leftArrowClick,
    rightArrowClick: rightArrowClick,
    renderPersonaliseButtons: renderPersonaliseButtons,
    mainClasses: classes,
    moreThanOneSA: moreThanOneSA
  }));
};
const styles = theme => {
  var _theme$palette$dialog, _theme$palette$dialog2;
  return {
    iconContainer: {
      display: "flex",
      width: "6%",
      justifyContent: "center",
      alignItems: "end",
      position: "relative"
    },
    footerContainer: {
      display: "flex",
      flex: 1,
      justifyContent: "flex-end"
    },
    tooltip: {
      textAlign: "center"
    },
    saBottom: {
      display: "flex",
      flexBasis: "95%",
      flexDirection: "row",
      justifyContent: "flex-end",
      margin: "12px 0px 0px 0px",
      "& > :first-child": {
        marginLeft: 16,
        marginRight: 16
      },
      flexWrap: "wrap"
    },
    saBodyArea: {
      display: "grid",
      flexDirection: "column"
    },
    header: {
      color: (_theme$palette$dialog = theme.palette.dialogues) === null || _theme$palette$dialog === void 0 ? void 0 : (_theme$palette$dialog2 = _theme$palette$dialog.expert) === null || _theme$palette$dialog2 === void 0 ? void 0 : _theme$palette$dialog2.text,
      minHeight: "40px",
      margin: "0 40px"
    },
    titleRoot: {
      padding: 8,
      color: theme.palette.text.primary
    },
    listItem: {
      flexDirection: "row",
      marginLeft: "25%",
      maxWidth: "75%",
      display: "flex"
    },
    responseWrapper: {
      display: "flex",
      flex: 1,
      position: "relative",
      borderRadius: 16,
      padding: "24px 20px 24px 20px",
      flexDirection: "column",
      "-webkit-tap-highlight-color": "transparent",
      backgroundColor: theme.palette.background.elevation2,
      boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)"
    },
    responseListItem: {
      display: "flex",
      flex: 1,
      padding: "0px 5px 0px 5px",
      flexDirection: "column",
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: 280
    },
    confidenceContainer: {
      display: "flex",
      flex: 1,
      justifyContent: "flex-end",
      alignItems: "flex-end",
      minHeight: 20,
      paddingRight: 10,
      marginBottom: 8
    },
    fullscreenBorderRadious: {
      borderBottomRightRadius: "15px",
      borderBottomLeftRadius: "15px"
    },
    arrowIcon: {
      fontSize: 28,
      cursor: "pointer",
      color: theme.palette.primary.main
    },
    arrowDisableIcon: {
      fontSize: 28,
      cursor: "default",
      color: theme.palette.text.disabled
    },
    arrowArea: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "5%",
      alignItems: "center"
    },
    outerBody: {
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      marginTop: 8
    },
    fullScreenIcon: {
      display: "flex",
      alignItems: "center",
      position: "absolute",
      right: 5,
      bottom: 5
    }
  };
};
export default withStyles(styles, {
  withTheme: true
})(withi18n(SuggestedAnswerDialogueCarousel));
SuggestedAnswerDialogueCarousel.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  handleFullScreen: PropTypes.func,
  dialogue: PropTypes.object,
  message: PropTypes.object.isRequired,
  suggestedAnswersProps: PropTypes.object
};
SuggestedAnswerDialogueCarousel.defaultProps = {
  suggestedAnswersProps: {
    hideDate: false,
    fullWidth: false
  }
};